import { BehaviorSubject, map, Observable, take, tap } from 'rxjs';
import { inject } from '@angular/core';
import { FiltersValues } from '../../application/models';
import { gameVisibilityAll } from '../../application/utils';
import { DistanceFilterStorage } from './distance-filter.storage';

export class FiltersStorage {
  private readonly distanceFilterStorage: DistanceFilterStorage = inject(DistanceFilterStorage);

  private startValue: FiltersValues = {
    showPrivateBlurred: gameVisibilityAll,
    maxDistanceMeters: this.distanceFilterStorage.selectedAsFilterValue
  } as FiltersValues;

  private filtersSubject: BehaviorSubject<FiltersValues> = new BehaviorSubject<FiltersValues>(this.startValue);

  readonly filters$: Observable<FiltersValues> = this.filtersSubject.asObservable();

  setFilters(data: Partial<FiltersValues>): Observable<void> {
    return this.filtersSubject.asObservable().pipe(
      take(1),
      tap((state: FiltersValues) => this.filtersSubject.next({ ...state, ...data })),
      map(() => void 0)
    );
  }
}
